<h3>Delivery For Fee <span class="highlight">(Click on an Delivery For Fee item to edit)</span></h3>
<a routerLink="/adddelivery" routerLinkActive="active" class="btn btn-default">Add Delivery For Fee</a>
<hr>
<div class="container divtable">
    <div class="divtablebody">
        <div class=" divrow">
            <div class="coltitle   appcol returncoldff">Return Doc No</div>
            <div class="coltitle   appcol productcoldff">Product Code</div> 
            <div class="coltitle   appcol datecoldff">Return date</div>
            <div class="coltitle   appcol btncoldff">&nbsp;</div> 
        </div>
        
        @for (deliveryforfee of deliveryforfees; track deliveryforfee.id) {
        <div class=" divrow" (click)="onEdit(deliveryforfee)">

            <div class=" appcol returncoldff  appcell">{{deliveryforfee.returndocno}}</div>
                
            <div class=" appcol productcoldff  appcell">{{deliveryforfee.productcode+": "+deliveryforfee.pdescription}}</div>
            
            <div class=" appcol datecoldff  appcell">{{ deliveryforfee.returndate == '0000-00-00' ? 'None' : (deliveryforfee.returndate | date: 'MM/dd/yyyy') }}</div>

             <div class=" appcol btncoldff appcell">
              <button class="delete btn-xs btn-danger" (click)="deleteDeliveryForFee(deliveryforfee); $event.stopPropagation()">Delete</button>    
            </div>
        </div>
        }
     </div>
</div>